import { type Navtab } from "../schema";

const navTabs: Navtab[] = [
  {
    id: "cult",
    hasSublinks: true,
    name: "Cult",
    sublinks: [
      { href: `/cult`, hash: `/principals`, label: "Principals" },
      { href: `/cult`, hash: `/team`, label: "Team" },
      { href: `/cult`, hash: `/cultivators`, label: "Cultivators" },
      { href: `/cult`, hash: `/innovators`, label: "Innovators" },
    ],
    to: "/cult",
  },
  {
    id: "collective",
    hasSublinks: true,
    name: "Collective",
    sublinks: [
      { href: `/collective`, hash: `/members`, label: `Members` },
      { href: `/collective`, hash: `/partners`, label: `Partners` },
    ],
    to: "/collective",
  },
  {
    id: "cultivation",
    hasSublinks: true,
    name: "Cultivation",
    sublinks: [
      { href: `/`, hash: `studio`, label: `Studio` },
      { href: `/`, hash: `bureau`, label: `Bureau` },
      { href: `/cultivation`, hash: `/programs`, label: `Programs` },
      { href: `/cultivation`, hash: `/client`, label: `Clients` },
    ],
    to: "/cultivation",
  },
  {
    id: "culture",
    hasSublinks: true,
    name: "Culture",
    sublinks: [
      { href: ``, hash: `/cultivators`, label: `Cultivators` },
      { href: `/culture`, hash: `/article`, label: `Articles` },
      { href: `/culture`, hash: `/event`, label: `Events` },
      { href: `/culture`, hash: `/news`, label: `News` },
      { href: `/culture`, hash: `/podcasts`, label: `Podcasts` },
    ],
    to: "/culture",
  },
];

export default navTabs;
